import React, { useEffect, useState } from 'react';
import { getEmpleadosService } from '../services/getEmpleadosService';
import { deleteEmpleadoService } from '../services/deleteEmpeladoService';
import UsuarioForm from './UsuarioForm';
import { ROLES } from '../utils/roles';
import { useNavigate } from 'react-router-dom';

const EmpleadoList = () => {
    const [empleados, setEmpleados] = useState([]);
    const [error, setError] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [modalVisible, setModalVisible] = useState(false);
    const [emailSeleccionado, setEmailSeleccionado] = useState('');

    const navigate = useNavigate();

    const cargarEmpleados = async () => {
        try {
            const data = await getEmpleadosService();
            setEmpleados(data);
        } catch (err) {
            setError(err.mensaje || 'Error al cargar empleados');
        }
    };

    useEffect(() => {
        cargarEmpleados();
    }, []);

    const onVolver = () => {
        navigate(-1);
    };

    const handleEliminar = async (email) => {
        if (!window.confirm(`¿Estás seguro de eliminar al empleado ${email}?`)) return;
        try {
            const res = await deleteEmpleadoService(email);
            setMensaje(res.mensaje || 'Empleado eliminado correctamente');
            setEmpleados((prev) => prev.filter((e) => e.email !== email));
        } catch (err) {
            setError(err.mensaje || 'Error al eliminar empleado');
        }
    };

    const handleEditar = (email) => {
        setEmailSeleccionado(email);
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
        setEmailSeleccionado('');
        cargarEmpleados();
    };

    return (
        <div className="max-w-2xl mx-auto">
            <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-6 space-y-4">
                <h2 className="text-xl font-semibold text-gray-900">Lista de Empleados</h2>
                {mensaje && <p className="text-sm text-green-600 bg-green-50 border border-green-200 rounded-md px-3 py-2">{mensaje}</p>}
                {error && <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2">{error}</p>}

                {empleados.length === 0 ? (
                    <p className="text-sm text-gray-500">No hay empleados registrados.</p>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">DNI</th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nombre</th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Apellido</th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Acciones</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {empleados.map((emp) => (
                                    <tr key={emp.email} className="hover:bg-gray-50">
                                        <td className="px-4 py-3 text-sm text-gray-700">{emp.email}</td>
                                        <td className="px-4 py-3 text-sm text-gray-700">{emp.dni}</td>
                                        <td className="px-4 py-3 text-sm text-gray-700">{emp.firstName}</td>
                                        <td className="px-4 py-3 text-sm text-gray-700">{emp.lastName}</td>
                                        <td className="px-4 py-3 text-sm">
                                            <div className="flex gap-2">
                                                <button className="px-3 py-1 bg-primary-600 text-white text-xs rounded hover:bg-primary-700 transition-colors"
                                                    onClick={() => handleEditar(emp.email)} title="Editar">Editar</button>
                                                <button className="px-3 py-1 bg-danger-600 text-white text-xs rounded hover:bg-danger-700 transition-colors"
                                                    onClick={() => handleEliminar(emp.email)}>Eliminar</button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                <button onClick={onVolver} className="px-4 py-2 bg-gray-500 text-white text-sm rounded-md hover:bg-gray-600 transition-colors">Volver</button>
            </div>

            {modalVisible && (
                <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full relative">
                        <button className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 text-lg" onClick={cerrarModal}>✕</button>
                        <UsuarioForm
                            emailUsuarioActual={emailSeleccionado}
                            rol={ROLES.PROPIETARIO}
                            onGuardar={cerrarModal}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default EmpleadoList;
